import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-79db6c5a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "m-1 my-half dropdown-divider"
};
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", null, [
        (_ctx.showMenu)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "p-1 dropdown-menu contextMenu",
                style: _normalizeStyle(_ctx.contextMenuStyle),
                onMouseleave: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                    return (_openBlock(), _createElementBlock("span", { key: option }, [
                        (option.text === 'separator')
                            ? (_openBlock(), _createElementBlock("hr", _hoisted_1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                onClick: ($event) => (_ctx.onMenuItemClick(option)),
                                class: _normalizeClass('p-1 py-half dropdown-item' +
                                    (option.enabled ? '' : ' disabled')),
                                href: "#"
                            }, _toDisplayString(option.text), 11, _hoisted_2))
                    ]));
                }), 128))
            ], 36))
            : _createCommentVNode("", true),
        _createElementVNode("div", {
            onContextmenu: _cache[1] || (_cache[1] = _withModifiers(
            //@ts-ignore
            (...args) => (_ctx.onRightClick && _ctx.onRightClick(...args)), ["right", "prevent"]))
        }, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 32)
    ]));
}
